module.exports = __webpack_public_path__ + "img/B4B29D_442D0D_604E2A_736542-256px.66cfe550.png";